import { URL } from '../variables';

let lastRequestAt = null;
const lastKeydowns = new WeakMap();

export function registerTextKeydown(event) {
    lastKeydowns.set(event.currentTarget, Date.now());
}

// Records an indication only. It never blocks or changes the candidate's answer.
export function logTextInsertion(event, { user, token, processo, context }) {
    const input = event.nativeEvent || event;
    if (user?.accessibility == true || input.isComposing || typeof input.data !== 'string') return;
    if (!['insertText', 'insertReplacementText', 'insertFromDictation'].includes(input.inputType)) return;
    const caracteres = Array.from(input.data).length;
    if (caracteres <= 5) return;
    const now = Date.now();
    const lastKeydown = lastKeydowns.get(event.currentTarget);
    if (lastKeydown !== undefined && now - lastKeydown < 1500) return;
    if (lastRequestAt !== null && now - lastRequestAt < 90000) return;
    lastRequestAt = now;
    return fetch(`${URL}api/salvar_log?v=a`, {
        method: 'POST',
        headers: { Accept: 'application/json', Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
            screen: 'permission', processo_id: processo.id, processo_name: processo.name,
            msg: 'Possível inserção de texto em bloco. ' + JSON.stringify({ ...context, inputType: input.inputType, caracteres })
        })
    }).catch(() => {});
}
